import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http'
import { Observable } from 'rxjs';
import { CallDetails } from '../models/call-details.model'
import { Pagination } from '../models/pagination.model'
import { AuthService } from './auth.service';
import { Item } from '../models/item.model';
import { AuthOperatorService } from './auth-operator.service';
import { environment } from './../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MgService {

  public phoneMask: string;

  private apiUrl: string = environment.apiUrl;

  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json"
    })
  }

  httpAuthOperatorOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      "Authorization": this.authOperator.tokenData,
    })
  }

  httpAuthOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      "Authorization": this.auth.tokenData,
    })
  }

  constructor(
    private httpClient: HttpClient,
    private authOperator: AuthOperatorService,
    private auth: AuthService,
  ) {}

  public nineExtra(number){
    if (number === null || number === undefined) {
      this.phoneMask = '(00)00000-0000'
      return '00000000000'
    } else {
      number = number.replace(/\^\s+|\s+$/gm, '');
      number = number.replace(/\-/g, '');
      if(number.length < 9){
        this.phoneMask = '0000-0000'
        return number
      } else if (number.length >= 9 && number.length < 10){
        this.phoneMask = '00000-0000'
        return number
      } else if (number.length == 10) {
        this.phoneMask = '(00)0000-0000'
        return number
      } else if (number.length > 10) {
        this.phoneMask = '(00)00000-0000'
        return number
      }
    }
  }

  public listHomeInfos(): Observable<any>{
    return this.httpClient.get<any>(
      `${this.apiUrl}/api/call/home/details`,
      this.httpAuthOperatorOptions
    )
  }

  public listCalls(
    page: number = 1,
    perPage: number = 10,
    statuses: any[] = null,
    excludeStatuses: any[] = null,
    businesses: number[] = null,
    businessUsers: number[] = null,
    operators: number[] = null,
    range: any = null,
    text: any = null,
  ): Observable<Pagination>{
    let listParameter = new HttpParams;
    listParameter = listParameter.set('page', page.toString());
    listParameter = listParameter.set('perpage', perPage.toString());

    if(statuses){
      listParameter = listParameter.set('statuses', statuses.toString());
    } else {
      listParameter = listParameter.set('statuses', ['A', 'T'].toString());
    }

    if(excludeStatuses) {
      listParameter = listParameter.set('except_statuses', excludeStatuses.toString());
    }

    if(businesses) {
      listParameter = listParameter.set('businesses', businesses.toString());
    }

    if(businessUsers) {
      listParameter = listParameter.set('business_users', businessUsers.toString());
    }

    if(operators) {
      listParameter = listParameter.set('users', operators.toString());
    }

    if(range) {
      listParameter = listParameter.set('range', `${range.start},${range.end}`);
    }

    if(text) {
      listParameter = listParameter.set('text', text.toString());
    }

    return this.httpClient.get<Pagination>(
      `${this.apiUrl}/api/call/list`,
      {
        params: listParameter,
        ...this.httpAuthOperatorOptions
      }
    )
  }

  public getCallByIdentifier(identifier: string): Observable<Pagination>{
    return this.httpClient.get<Pagination>(
      `${this.apiUrl}/api/call/${identifier}`,
      this.httpAuthOperatorOptions
    )
  }

  public postCallDetails(identifier: string, details: CallDetails): Observable<any>{
    return this.httpClient.post<any>(
      `${this.apiUrl}/api/call/${identifier}/details`,
      details,
      this.httpAuthOperatorOptions
    )
  }

  public searchBusiness(search: string): Observable<any> {
    return this.httpClient.get<any>(
      `${this.apiUrl}/api/business?search=${search}&perpage=5`,
      this.httpAuthOperatorOptions,
    );
  }

  public createBusinessUser(user: any): Observable<any> {
    return this.httpClient.post<any>(
      `${this.apiUrl}/api/user/business/create`,
      user,
      this.httpAuthOperatorOptions
    )
  }

  public listBusinessUser(business: string): Observable<Pagination>{
    return this.httpClient.get<Pagination>(
      `${this.apiUrl}/api/user/business/${business}/list`,
      this.httpAuthOperatorOptions
    )
  }

  public showBusinessUser(user: number): Observable<Pagination>{
    return this.httpClient.get<Pagination>(
      `${this.apiUrl}/api/user/business/${user}/show`,
      this.httpAuthOperatorOptions
    )
  }

  public storeBusinessUser(user: any): Observable<any> {
    return this.httpClient.post<any>(
      `${this.apiUrl}/api/user/business/store`,
      user,
      this.httpAuthOperatorOptions
    )
  }

  public removeBusinessUser(user_id: number): Observable<any> {
    return this.httpClient.delete<any>(
      `${this.apiUrl}/api/user/business/remove/${user_id}`,
      this.httpAuthOperatorOptions
    )
  }

  public listAllUser(
    search: string = '',
    page: number = 1,
    perPage: number = 10,
    all: string = ''
  ): Observable<Pagination>{
    return this.httpClient.get<Pagination>(
      `${this.apiUrl}/api/user/business/list?search=${search}&page=${ page.toString() }&perpage=${ perPage.toString()}&all=${all}`,
      this.httpAuthOperatorOptions
    )
  }

  public listAllBusiness(search: string = '', page: number = 1, perPage: number = 10): Observable<Pagination>{
    return this.httpClient.get<Pagination>(
    `${this.apiUrl}/api/clients?search=${search}&page=${ page.toString() }&perpage=${ perPage.toString() }`,
    this.httpAuthOperatorOptions
    )
  }

  public listUser(): Observable<Pagination>{
    return this.httpClient.get<Pagination>(
      `${this.apiUrl}/api/staff`,
      this.httpAuthOperatorOptions
    )
  }

  public createOs(os: any): Observable<any>{
    return this.httpClient.post<any>(
      `${this.apiUrl}/api/os/create`,
      os,
      this.httpAuthOperatorOptions
    )
  }
  // Client routes

  public searchBusinessUser(email: string): Observable<Pagination>{
    return this.httpClient.get<Pagination>(
      `${this.apiUrl}/api/client/search?email=${ email }`,
      this.httpOptions
    )
  }

  public listBusinessUserCalls(page: number = 1, perPage: number = 10): Observable<Pagination>{
    return this.httpClient.get<Pagination>(
      `${this.apiUrl}/api/client/my/calls?page=${ page.toString() }&perpage=${ perPage.toString() }`,
      this.httpAuthOptions
    )
  }

  public getClientCallByIdentifier(identifier: string): Observable<Pagination>{
    return this.httpClient.get<Pagination>(
      `${this.apiUrl}/api/client/my/calls/${identifier}`,
      this.httpAuthOptions
    )
  }

  public saveBusinessUser(user: any): Observable<any> {
    return this.httpClient.post<any>(
      `${this.apiUrl}/api/client/profile`,
      user,
      this.httpAuthOptions
    )
  }

  public loadBusinessUserUsage(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.apiUrl}/api/client/usage`,
      this.httpAuthOptions
    )
  }

  public loadBusinessInvoiceList(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.apiUrl}/api/client/invoices`,
      this.httpAuthOptions
    )
  }

  public loadBusinessInvoice(bill: string): Observable<any> {
    return this.httpClient.get<any>(
      `${this.apiUrl}/api/client/invoices/${bill}`,
      this.httpAuthOptions
    )
  }

  public changeBusinessUserPassword(newPassword: any): Observable<any>{
    return this.httpClient.post<any>(
      `${this.apiUrl}/api/oauth/client/password/change`,
      newPassword,
      this.httpAuthOptions
    )
  }

  public postCallWithoutRegister(call: any): Observable<any>{
    return this.httpClient.post<any>(
      `${this.apiUrl}/api/client/call/unregistered`,
      call,
      this.httpOptions
    )
  }

  public setCallBusiness(uuid: string, business: number): Observable<any>{
    return this.httpClient.put<any>(
      `${this.apiUrl}/api/call/${uuid}/business`,
      {business: business},
      this.httpAuthOperatorOptions
    )
  }

  // Client and Operators routes

  public postCallItem(identifier: string, item: Item): Observable<any>{
    // item.origin ==
    return this.httpClient.post<any>(
      item.origin == 'A' ? `${this.apiUrl}/api/call/${identifier}/entry`
        : `${this.apiUrl}/api/client/my/calls/${identifier}/entry`,
      item,
      item.origin == 'A' ? this.httpAuthOperatorOptions : this.httpAuthOptions,
    )
  }

  public notifyUserOperator(identifier: string, userId: number): Observable<any>{
    return this.httpClient.post<any>(
      `${this.apiUrl}/api/call/${identifier}/notify`,
      {
        userId: userId
      },
      this.httpAuthOperatorOptions,
    )
  }

  public completeToggleEntry(entry: number): Observable<any> {
    return this.httpClient.post(`${this.apiUrl}/api/call/entry/toggle/complete`,
      {
        response: entry
      },
      this.httpAuthOperatorOptions
    )
  }

  public postCall(call: any, type: string = "O"): Observable<any> {
    return this.httpClient.post<any>(
      type == "O" ? `${this.apiUrl}/api/call/create` : `${this.apiUrl}/api/client/my/calls/create`,
      call,
      type == "O" ? this.httpAuthOperatorOptions : this.httpAuthOptions,
    )
  }

  public listFilterCallDetails(): Observable<any> {
    return this.httpClient.get<Pagination>(
      `${this.apiUrl}/api/call/filter/details`,
      this.httpAuthOperatorOptions
    )
  }

  public getPhrase(): Observable<any> {
    return this.httpClient.get<Pagination>(
      `${this.apiUrl}/api/ws/third/phrase`,
      this.httpAuthOperatorOptions
    )
  }

  public postCallFiles(files: any, operator: boolean): Observable<any> {
    return this.httpClient.post<Pagination>(
      operator ? `${this.apiUrl}/api/call/files` : `${this.apiUrl}/api/client/call/files`,
      files,
      {
        headers: new HttpHeaders({
          "Authorization": operator ? this.authOperator.tokenData : this.auth.tokenData,
        })
      }
    )
  }

  public downloadCallFile(path: string): Observable<any> {
    return this.httpClient.post<any>(
      this.auth.tokenData != " " ? `${this.apiUrl}/api/client/call/files/download` : `${this.apiUrl}/api/call/files/download`,
      {path: path},
      {
        responseType: 'blob' as 'json',
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          "Authorization": this.auth.tokenData != " " ? this.auth.tokenData : this.authOperator.tokenData ,
        })
      }
    )
  }
}

//
